import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Self Finance Courses</h1>
                <p>Home &gt; Self Finance Courses</p>
            </div>
        </div>
    );
};

export default Hero;
